export interface FibuHonorarKostenart {
    sachkonto: string;
    kostenstelle_suffix: string;
}

export interface FibuHonorarTa {
    fibu_honorar_ta_id?: number;
    bezeichnung?: string;
    kostenstelle_suffix?: string;
    tierarzt_id?: number;
    tierarzt?: string;
    tierarzt_titel?: string;
    tierarzt_vorname?: string;
    tierarzt_nachname?: string;
    aktiv?: number;
    kommentar?: string;
    anzeige?: string;
    kostenarten_map?: string;
    kostenarten?: FibuHonorarKostenart[];
}

export const FIBU_HONORAR_DEFAULT_KOSTENARTEN: { sachkonto: string; label: string }[] = [
    { sachkonto: '4780', label: '4780 Honorar' },
    { sachkonto: '4760', label: '4760 Gehälter' },
];
